import {Avatar, Image, Tabs} from 'antd'
import getAvatar from 'helpers/getAvatar'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {renderIf} from 'views/Shared'
import classNames from "classnames";
import {renderIfElse} from "../../../Shared";
import ImageLoader from "../../../../components/ImageLoader";
import EmptyHolder from "../../../../components/EmptyHolder";
import {ItemInformation} from 'components/common/ItemInformation'
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {formatDate, renderFromToDate, renderFromToTime} from "../../../../helpers/datetimeHelpers";
import {FaUserGraduate} from "react-icons/fa6";
import {IdentifierTypes} from "../../appFieldTypes";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {BsInfoCircleFill} from "react-icons/bs";
import getAliasName from "../../../../helpers/getAliasName";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {NoImage} from "../../../../conts/imageBase64";
import {GoDotFill} from "react-icons/go";
import {MdContactPhone} from "react-icons/md";
import {renderEmptyHolderMember} from "../../CatholicHousehold/functions/renderEmptyHolderMember";

const StudentViewCard = ({item}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {
        avatar,
        user,
        identifier_type,
        identifier_code,
        student_idcode,
        contact_address,
        student_subject_results = [],
        course_students = [],
        medal_awards = [],
        diocese,
        edit,
        parish,
        notes,
        patron_saint_name,
        prefix_title,
        fullname,
        contact_phone,
        contact_email,
        date_of_birth,
        place_of_birth,
        gender,
        religious_order,
        religious_order_name,
    } = item ?? {}

    const typeIdentify = _.find(IdentifierTypes, {value: identifier_type})?.label
    const [current, setCurrent] = useState('0')

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                    title="student information"
                    className="text-sm text-color-400"
                />
                <div className="flex gap-3">
                    <ImageLoader
                        style={{width: isSm ? 100 : 130, height: isSm ? 100 : 130}}
                        src={avatar || NoImage}
                        fallback={NoImage}
                        className="background-200 rounded-lg object-cover mt-1"
                    />
                    <div className="flex flex-col flex-1 min-w-0 gap-1">
                        <ItemInformation
                            primary={true}
                            showIcon={true}
                            className="text-sm"
                            label={!isSm && "full name"}
                            value={`${getAliasName(item, 'patron_saint') || ''} ${fullname}`}
                        />
                        <ItemInformation showIcon={true} className="text-xs italic" label="student code"
                                         value={`#${student_idcode}`}/>
                        {renderIf(
                            edit === true && identifier_type,
                            <ItemInformation
                                showIcon={true}
                                className="italic tracking-wider"
                                label={typeIdentify}
                                value={identifier_code}/>
                        )}
                        {renderIf(
                            gender !== 0,
                            <ItemInformation showIcon={true} label={!isSm && "gender"}
                                             value={t(getLabelOfGender(gender))} className="italic tracking-wider"/>
                        )}
                        {renderIf(
                            _.some([date_of_birth, place_of_birth]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst={!isSm && "date of birth"}
                                valueFirst={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                labelSecond={place_of_birth ? ' - ' : ''}
                                valueSecond={place_of_birth}
                                className="italic tracking-wider"
                            />
                        )}
                        {renderIf(
                            notes,
                            <ItemInformation showIcon={true} label="note" value={notes} className="text-xs italic"/>
                        )}
                    </div>
                </div>
            </div>

            {renderIf(
                user,
                <div className="flex items-center gap-3">
                    <Avatar
                        size={36}
                        src={getAvatar(user)}
                        icon={<FaUserGraduate size={18} className="text-color-500"/>}
                        className="flex flex-center background-200"
                    />
                    <div className="flex flex-col">
                            <span className="text-xs text-color-500 italic leading-tight">
                                {`${t('link account')} : `}
                            </span>
                        {renderIfElse(
                            edit === true,
                            <Link target="_blank" to={getLinkToDetail(user)}
                                  className="font-medium text-primary-700 no-underline leading-snug">
                                {getAliasName(user, 'patron_saint')}
                                {` ${getTitle(user)}`}

                            </Link>,
                            <span className="font-medium text-primary-700 leading-snug">
                                    {getAliasName(user, 'patron_saint')}
                                {getTitle(user)}
                                </span>
                        )}
                    </div>
                </div>
            )}
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={<MdContactPhone size={14} className="text-color-500 mr-1"/>}
                    title="contact"
                    className="text-sm text-color-400"
                />
                <div className="ml-0 md:ml-1 space-y-1">
                    <ItemInformation showIcon={true} label="phone" value={contact_phone} className="italic tracking-wider"/>
                    <ItemInformation showIcon={true} label="email" value={contact_email} className="italic tracking-wider"/>
                    <ItemInformation showIcon={true} label="address" value={contact_address}
                                     className="italic tracking-wider"/>
                    {renderIf(
                        _.some([diocese, parish]),
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="parish"
                            valueFirst={parish?.name}
                            labelSecond={diocese && " - " || ''}
                            valueSecond={diocese?.fullname}
                            className="italic tracking-wider"
                        />
                    )}
                    {renderIf(
                        religious_order_name,
                        <ItemInformation
                            showIcon={true}
                            label={!isSm && "belong to religious order"}
                            value={
                                <Link to={getLinkToDetail(religious_order)} className="no-underline">
                                    {isSm && `${t('religious order')} `}{religious_order_name}
                                </Link>
                            }
                            className="italic tracking-wider"
                        />
                    )}
                </div>
            </div>
            <Tabs
                defaultActiveKey="0"
                onChange={setCurrent}
                centered
                size="small"
                tabBarStyle={{margin: '0 0 12px 0'}}
                items={[
                    {
                        key: '0',
                        label: t('courses'),
                        children: renderIfElse(
                            course_students.length > 0,
                            course_students.map((e, i) => {
                                const {
                                    course,
                                    registered_classes = [],
                                    medal_awards = [],
                                    result_date,
                                    result_status,
                                } = e ?? {};

                                let label_status;
                                let color_status;
                                switch (result_status) {
                                    case 1:
                                        label_status = 'passed';
                                        color_status = 'text-green-600';
                                        break;
                                    case 0:
                                        label_status = 'failed';
                                        color_status = 'text-red-600';
                                        break;
                                    default:
                                        label_status = 'not assessed yet';
                                        color_status = 'text-color-300';
                                        break;
                                }

                                return (
                                    <div
                                        key={i}
                                        className="py-2 flex flex-col gap-1 custom-render-border rounded-md relative"
                                    >
                                        <Link
                                            to={getLinkToDetail(course)}
                                            target="_blank"
                                            className="font-bold text-sm text-color-000 no-underline"
                                        >
                                            {getTitle(course)}
                                        </Link>

                                        {renderIf(
                                            registered_classes.length > 0,
                                            registered_classes.map((e, i) => (
                                                <div
                                                    key={i}
                                                    className="space-x-1 text-xs text-color-400 italic"
                                                >
                                                    <GoDotFill size={10} className="text-color-500"/>
                                                    <span>{t('learn in the class')}</span>
                                                    <Link
                                                        to={getLinkToDetail(e)}
                                                        target="_blank"
                                                        className="font-bold text-color-100 no-underline"
                                                    >
                                                        {getTitle(e)}
                                                    </Link>
                                                    {renderIf(
                                                        e?.from_date,
                                                        <span className="text-color-400">
                        {'( '}
                                                            {renderFromToDate(e?.from_date, e?.to_date)}
                                                            {' )'}
                      </span>
                                                    )}
                                                </div>
                                            ))
                                        )}

                                        {renderIf(
                                            result_status !== null,
                                            <span
                                                style={{position: 'absolute', top: 5, right: 5}}
                                                className={classNames(
                                                    'font-bold text-2xs tracking-wide uppercase opacity-70',
                                                    color_status
                                                )}
                                            >
                  {t(label_status)}
                </span>
                                        )}
                                    </div>
                                );
                            }),
                            renderEmptyHolderMember()
                        ),
                    },
                    {
                        key: '1',
                        label: t('subject results'),
                        children: renderIfElse(
                            student_subject_results.length > 0,
                            student_subject_results.map((e, i) => {
                                const {
                                    subject,
                                    course_class,
                                    result_date,
                                    result_status,
                                    score_type,
                                    score_text,
                                    score_number,
                                } = e ?? {};

                                let label_status;
                                let color_status;
                                switch (result_status) {
                                    case 1:
                                        label_status = 'passed';
                                        color_status = 'text-green-600';
                                        break;
                                    case 0:
                                        label_status = 'failed';
                                        color_status = 'text-red-600';
                                        break;
                                    default:
                                        label_status = 'not assessed yet';
                                        color_status = 'text-color-300';
                                        break;
                                }

                                return (
                                    <div
                                        key={i}
                                        className="py-2 space-y-1 custom-render-border rounded-md relative"
                                    >
              <span className="font-bold text-sm text-color-000">
                <span className="mr-1 font-medium text-xs text-color-400 italic">
                  {t('subjects')}
                </span>
                  {getTitle(subject)}
              </span>
                                        <div className="flex flex-col md:flex-row gap-x-4 gap-y-1">
                                            {renderIf(
                                                _.some([score_text, score_number > 0]),
                                                <ItemInformation
                                                    showIcon={true}
                                                    label="score"
                                                    value={renderIfElse(
                                                        score_type === 'text',
                                                        score_text,
                                                        score_number
                                                    )}
                                                    className="text-xs italic"
                                                />
                                            )}
                                            <ItemInformation
                                                showIcon={true}
                                                label="result date"
                                                value={formatDate(result_date, 'DD/MM/YYYY')}
                                                className="text-xs italic"
                                            />
                                        </div>
                                        <div className="space-x-1 text-xs text-color-500 italic">
                                            <GoDotFill size={10} className="text-color-500"/>
                                            <span>{t('learn in the class')}</span>
                                            <span className="font-bold text-color-100">
                  {getTitle(course_class)}
                </span>
                                            <span>{t('in the course')}</span>
                                            <span className="font-bold text-color-000">
                  {getTitle(course_class?.course)}
                </span>
                                            {renderIf(
                                                course_class?.from_date,
                                                <span className="font-medium text-color-300">
                    ({renderFromToTime(course_class?.from_date, course_class?.to_date)})
                  </span>
                                            )}
                                        </div>
                                        {renderIf(
                                            result_status !== null,
                                            <span
                                                style={{position: 'absolute', top: 10, right: 10}}
                                                className={classNames(
                                                    'font-bold text-2xs tracking-wide uppercase opacity-70',
                                                    color_status
                                                )}
                                            >
                  {t(label_status)}
                </span>
                                        )}
                                    </div>
                                );
                            }),
                            <EmptyHolder/>
                        ),
                    },
                    {
                        key: '2',
                        label: t('certification awarded'),
                        children: renderIfElse(
                            medal_awards.length > 0,
                            medal_awards.map((e, i) => {
                                const {medal, eff_date, ref} = e ?? {};
                                return (
                                    <div key={i} className="flex items-center gap-3">
                                        {renderIf(
                                            medal?.avatar,
                                            <Image
                                                src={medal?.avatar}
                                                style={{width: 80}}
                                                className="object-cover"
                                            />
                                        )}
                                        <div className="flex flex-col">
                <span className="font-bold text-primary">
                  {getTitle(medal)}
                </span>
                                            <ItemInformation
                                                showIcon={true}
                                                label="date of award"
                                                value={formatDate(eff_date, 'DD/MM/YYYY')}
                                                className="text-xs italic"
                                            />
                                            <ItemInformation
                                                showIcon={true}
                                                label="by"
                                                value={
                                                    <Link
                                                        to={getLinkToDetail(ref)}
                                                        target="_blank"
                                                        className="text-color-000 no-underline"
                                                    >
                                                        {getTitle(ref)}
                                                    </Link>
                                                }
                                                className="text-xs italic"
                                            />
                                        </div>
                                    </div>
                                );
                            }),
                            renderEmptyHolderMember()
                        ),
                    },
                ]}
            />
        </div>
    )
}

export default StudentViewCard
